export const accountSectionConfig = {
  greet: 'Greetings,',
  greetings: '<Location Name> Account Access !',
  alertMessage: 'Your gate has locked out, please pay the due amount to unlock',
  accountTitle: 'Account Selection',
  paymentAlert: 'Payment Due',
  buttonConfig: 'View Account',
  back: 'back',
  logOut: 'Log Out',
  balance: 'Balance : $',
  unit: 'Rented Unit',
  reservedUnitTypes: 'Reserved Unit types',
  noUnitsAvailable: 'No Units Available',
  callFacility: 'Please Call The Facility',
  noReservations: 'No reservations to display',
};

export const contactDetails = {
  mailingAddress: '5877 Cauterskill Rd, Catskill, NY 12414',
  emailID: 'catskillselfstorage@gmail.com',
  phoneNumber: '518-943-3003',
  facilityDetails: {
    facilityAddress: '5877 Cauterskill Rd, Catskill, NY 12414',
    googleMapsUrl: 'https://goo.gl/maps/M3q1BkM2gybTPvJt7',
    facilityName: 'Catskill Self Storage',
  },
};
